import { mediaObjectProvider } from "@/@core/http";
import { refreshToken } from "@/@core/utils/refreshToken";
import { stripDownloadSuffix } from "@/@core/utils/stripDownloadSuffix";

export const sendToServer = async (file, generateSizes = []) => {
  const response = await mediaObjectProvider.post({ file, generateSizes });
  return {
    contentUrl: response.contentUrl,
    "@id": stripDownloadSuffix(response["@id"]),
  };
};

export const downloadMediaObject = async (fileId, fileName) => {
  const url = process.env.VUE_APP_API + stripDownloadSuffix(fileId) + "/download";
  const fetchOpts = { method: "GET", credentials: "include" };

  let response = await fetch(url, fetchOpts);
  if (response.status === 401) {
    await refreshToken();
    response = await fetch(url, fetchOpts);
  }
  if (!response.ok) {
    throw new Error(`Download failed: ${response.statusText}`);
  }

  const blobUrl = URL.createObjectURL(await response.blob());
  try {
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = fileName || "download";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } finally {
    URL.revokeObjectURL(blobUrl);
  }
};
